import { required, optional } from 'AppReact/schema';

export default {
    active: required('boolean'),
    code: optional('string'),
    external_id: optional('string'),
    icon: optional('string'),
    id: required('integer'),
    lat: optional('string'),
    lng: optional('string'),
    name: required('string'),
    region: required('string')
}